import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import { ReactComponent as SuccessIcon } from '@/img/bookings/success.svg';

const SettlePaymentBankTransferResult = ({ request, bookings, isMultiMode, onClose }) => {
	const { t } = useTranslation();

	const coveredBookings = isMultiMode ? bookings || [] : [];

	return (
		<div className="settle-payment-wrap bank-transfer__result">
			<div className="bank-transfer__result-content">
				<SuccessIcon className="bank-transfer__result-icon" />
				<div className="bank-transfer__result-title">{t('Bookings.SettlePayment.BankTransferSubmitted')}</div>
				<div className="bank-transfer__result-text">{t('Bookings.SettlePayment.BankTransferSubmittedText')}</div>

				{request?.reference_number && (
					<div className="bank-transfer__reference">
						<span className="bank-transfer__reference-label">{t('Bookings.SettlePayment.RequestId')}:</span>
						<span className="bank-transfer__reference-value">{request.reference_number}</span>
					</div>
				)}

				{coveredBookings.length > 0 && (
					<div className="bank-transfer__covered">
						<div className="bank-transfer__covered-title">
							{t('Bookings.SettlePayment.BankTransferCoveredReservations')}
						</div>
						<div className="bank-transfer__covered-list">
							{coveredBookings.map((booking) => (
								<div className="bank-transfer__covered-item" key={booking.id}>
									{booking?.short_id || booking?.id}
								</div>
							))}
						</div>
					</div>
				)}
			</div>

			<div className="bank-transfer__result-actions">
				<Button variant="contained" className="bank-transfer__finish-button" onClick={onClose}>
					{t('Bookings.SettlePayment.Finish')}
				</Button>
			</div>
		</div>
	);
};

export default SettlePaymentBankTransferResult;
